import { useState, type ReactNode } from 'react';
import { Button } from './button';
import { Dialog, DialogContent, DialogFooter, DialogHeader } from './overlays';
import { toast } from './toast';

/** A yes or no question before something destructive. Rendered while open; the parent unmounts it on close. */
export function ConfirmDialog({
  title,
  description,
  confirm,
  onConfirm,
  onClose,
  danger = true,
}: {
  title: string;
  description?: ReactNode;
  /** Label of the confirming button. */
  confirm: string;
  onConfirm: () => Promise<void> | void;
  onClose: () => void;
  danger?: boolean;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent size="sm">
        <DialogHeader title={title} description={description} />
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} autoFocus>
            Cancel
          </Button>
          <Button
            variant={danger ? 'danger' : 'primary'}
            loading={busy}
            onClick={() => {
              setBusy(true);
              void Promise.resolve(onConfirm())
                .then(onClose)
                .catch((err: unknown) => toast.error(err))
                .finally(() => setBusy(false));
            }}
          >
            {confirm}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
